import { graphql } from '@/gql';
import type { UpdateNlFormMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateNLForm = async ({ id, data }: UpdateNlFormMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation UpdateNLForm($id: String!, $data: UpdateFormStackType!) {
        updateNLForm(id: $id, data: $data) {
          id
          formstackId
          createdAt
          updatedAt
          alternativePhoneNumber1
          alternativePhoneNumber2
          approvedByUm
          bestCallBackTime
          callerId
          cashAmountPaid
          correctDropOffAddress
          correctPickupAddress
          customersName
          customerCurrentTime
          dateOfRefundCredit
          details
          didTheClientSeeOrMeetTheDriver
          didTheClientSpeakWithTheDriver
          didTheDriverAttemptToCallUs
          didWeAttemptToCallTheClient
          driverNameAndNumber
          driverNoWantForGoGo
          driversLicensePlateNumber
          emailAddress
          endingAddress
          goGoCredits
          goGoingSince
          goGoRefund
          nameOfFacility
          natureOfComplaint
          operatorsName
          partnerCode
          phoneNumber
          reason
          reasonForClosing
          reasonForNotUsingOrNotNeedingService
          reasonForSuspending
          requestedMembershipRefund
          requestId
          returnAddress
          returnAddressType
          serviceType
          specialNotesForRefund
          startingAddress
          statusOfComplaint
          supervisorName
          supervisorNotesUpdates
          suspendEndDate
          suspendStartDate
          typeOfAlternativeTransportation
          typeOfCancellation
          uberLyftRefund
          vasName
          vendorRefunded
          wasTheClientWaitingOutsideIfNotWhereWasTheClientWaiting
          whereWasTheClientWaiting
          whichVendorWasThisTripWith
          whosCallingPhoneNumber
          customerConcern
          resolution
          offer
          retained
        }
      }
    `),
  });

  return response.data?.updateNLForm ?? null;
};
